import { LookupItem } from "../models/lookup-item";
import { LookupValue } from "./lookup-value";

export class Qualification {
  type: LookupItem | null = null;
  institution = '';
  course = '';
  country: LookupValue | null = null;
  postcode = '';
  start = '';
  end = '';
}